import styled from 'styled-components';

export const PostStyles = styled.div`
  background: #1b1f2c;
  flex-grow: 1;
  
  img {
    width: 100%;
  }
  
  .registrationButton {
    margin-top: 40px;
  }
  
  .content {
    padding-top: 64px;
    padding-bottom: 100px;
    
    @media (max-width: 768px) {
      padding-top: 16px;
      padding-bottom: 56px;
    }
    
    h1 {
      margin-bottom: 24px;
    }
    
    a {
      text-decoration: underline;
    }
  }
`;
